import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === undefined) {
    return (
      <div
        data-testid="protected-loading"
        className="min-h-screen bg-slate-950 flex items-center justify-center"
      >
        <Loader2 size={28} className="animate-spin text-sky-400" />
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}
